import { takeLatest, put, call } from "redux-saga/effects";
import { setRolesSuccess, setRolesError, setRolesBegin } from "./slice";
import { selectRoles } from "./actions";
import { apiGet } from "api/callApi";

function* setRoles(val) {
  yield put(setRolesBegin());
  try {
    const newData = val.payload;
    if (newData) {
      const response = yield call(
        apiGet,
        `/v1/getroles/${newData.projectId}/${newData.userId}`
      );
      yield put(setRolesSuccess({ newData: response.data }));
    } else {
      yield put(setRolesError());
    }
  } catch (error) {
    yield put(setRolesError(error));
  }
}

export function* watchsetRoles() {
  yield takeLatest(selectRoles.type, setRoles);
}
